import createVueApp from '@/common/createApp'

const mountEmployeePage = (importPage) => async(props) => {
  const { default: Page } = await importPage()
  createVueApp(Page, { props, layout: null })
}

Styxie.Initializers.Welcome = {
  welcome_employee: mountEmployeePage(() => import('@/vue_widgets/welcome/welcome_employee/index.vue')),
  instruction_sent: mountEmployeePage(() => import('@/vue_widgets/welcome/instruction_sent/index.vue')),
  finishing_password_reset_employee: mountEmployeePage(() => import('@/vue_widgets/welcome/finishing_password_reset_employee/index.vue'))
}
